/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import type * as monaco from 'monaco-editor';

type ILanguage = monaco.languages.IMonarchLanguage;

export const calciteExplainTxtLanguage: ILanguage = {
  tokenizer: {
    root: [
      [/(Project|Limit|Exchange|Sort|TableScan)/, 'keyword'], // Main components
      [/\b(fields|exprs|fetch|distribution|collation|table|projects|est\. row count)\b/, 'variable'], // Field names
      [/\b[A-Z_]+\b/, 'constant'], // Constants like EXPR$0, PUBLIC, PERSON
      [/\b[0-9]+(?:\.[0-9]+)?(?:E[+-]?[0-9]+)?\b/, 'number'], // Numbers including scientific notation
      [/\[|\]/, 'delimiter'], // Brackets
      [/[:]/, 'operator'], // Colons separating fields
    ],
  },
};
